import oRequest from "../libsV2/request.js";
import { Toast } from "vant";

let URL = {
    LOCATION: "tool/location/transfromip",
    GET_GOODS_DETAIL: "shop/v4/goods/item",//产品详情
    GET_TOPIC_LISTS: "shop/topic/lists",
    GET_TOPIC_TOTAL: "shop/topic/total",
    COLLECT_GOODS: "comm/collect/collect",
    GET_QRCODE: "comm/qrcode/get",
    GET_GOODS_COMPARES:"shop/v4/goods/compares",
    GET_GOODS_SHARE_COMPARES:"shop/v4/goods/sharecompare",
    GET_GOODS_SHARE_COMPARE_LISTS:"shop/v4/goods/getcomparelists",
    GET_GOODS_SHARE_COMPARE_INFO:"shop/v4/goods/getcompare",
    GOODS_SHARE_COMPARE_DELETE:"shop/v4/goods/deletecompare",
    GOODS_SHARE_COMPARE_CHANNEL:"shop/v4/goods/channel",  // 销售渠道筛选
};

function getData(url, data = {}) {
    return new Promise((resolve, recject) => {
        oRequest.singleAjaxData(url, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
            }
        });
    });
}

export default {
    location(data) {
        return getData(URL.LOCATION, data);
    },
    getGoodsDetail(data) {
        return getData(URL.GET_GOODS_DETAIL, data);
    },
    getTopicLists(data) {
        return getData(URL.GET_TOPIC_LISTS, data);
    },
    getTopicTotal(data) {
        return getData(URL.GET_TOPIC_TOTAL, data);
    },
    collectGoods(data) {
        return getData(URL.COLLECT_GOODS, data);
    },
    getQrcode(data) {
        return getData(URL.GET_QRCODE, data);
    },
    getGoodsCompares(data) {
        return getData(URL.GET_GOODS_COMPARES, data);
    },
    getGoodsShareCompares(data) {
        return getData(URL.GET_GOODS_SHARE_COMPARES, data);
    },
    getGoodsShareCompareLists(data) {
        return getData(URL.GET_GOODS_SHARE_COMPARE_LISTS, data);
    },
    getGoodsShareCompareInfo(data) {
        return getData(URL.GET_GOODS_SHARE_COMPARE_INFO, data);
    },
    deleteGoodsShareCompare(data) {
        return getData(URL.GOODS_SHARE_COMPARE_DELETE, data);
    },
    getGoodsShareCompareChannel(data) {
        return getData(URL.GOODS_SHARE_COMPARE_CHANNEL, data);
    },
};
